module.exports = __webpack_public_path__ + "static/media/image-5.e2fd3704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-5.png
// module id = 2201
// module chunks = 0